import { inject, Injector, runInInjectionContext } from '@angular/core';
import { getCurrentInjector } from '@angular/core/primitives/di';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, RouterStateSnapshot } from '@angular/router';
import { from, of, Observable } from 'rxjs';
import { concatMap, first, defaultIfEmpty } from 'rxjs/operators';

type ValidGuards = CanActivateFn | CanMatchFn;

/**
 * OrGuard can be used as a CanActivateFn or as a function: OrGuard([guard1, guard2], route, state)
 * It supports guards as names (strings, resolved from registry) or as functions directly.
 */
export const OrGuard: ValidGuards & ((guards: ValidGuards[], route: ActivatedRouteSnapshot, state: any) => any) = (guardsOrRoute: any, maybeRoute?: any, maybeState?: any) => {
    let guards: ValidGuards[];
    let route: any;
    let state: any;

    if (Array.isArray(guardsOrRoute)) {
        guards = guardsOrRoute;
        route = maybeRoute;
        state = maybeState;
    } else {
        route = guardsOrRoute;
        state = maybeRoute;
        guards = route.data['guards'] as ValidGuards[];
    }

    if (!guards || guards.length === 0) {
        return of(true); // No guards specified, allow access
    }

    // const currentInjector = getCurrentInjector()
    const currentInjector = inject(Injector)
    return from(guards).pipe(
        concatMap(guard => {
            if (!guard) return of(false); // Guard not found, treat as false
            const result = runInInjectionContext(currentInjector, () => guard(route, state));
            if (result instanceof Observable) {
                return result;
            } else if (result instanceof Promise) {
                return from(result);
            } else {
                return of(result);
            }
        }),
        first(result => result === true, false), // emit first true, or false if none
        defaultIfEmpty(false)
    );
};